import React from "react";
import ReactDOM from "react-dom";
import HorizontalScroll from "react-scroll-horizontal";

class AnnotationsSlide extends React.Component {
  constructor(props) {
    super(props);
  }

  onItemClick(id) {
    this.props.onSelectAnnotation(id);
  }

  render() {
    const { annotations } = this.props;

    const items = annotations.map((value, index, arr) => {
      return (
        <AnnotationItem
          key={value.id}
          active={value.id === this.props.selectedAnnotation}
          ref={
            value.id === this.props.selectedAnnotation
              ? this.activeItemRef
              : null
          }
          text={value.text}
          type={value.type}
          onClick={() => this.onItemClick(value.id)}
        />
      );
    });

    return (
      <div className="AnnotationsPanel">
        <div className="Fade Left" />
        {items.length > 2 ? (
          <HorizontalScroll className="HorizontalScroll" reverseScroll={true}>
            {items}
          </HorizontalScroll>
        ) : (
          items
        )}
        <div className="Fade Right" />
      </div>
    );
  }
}

export default AnnotationsSlide;

class AnnotationItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasReadMore: false };

    this.textRef = React.createRef();
  }

  componentDidMount() {
    const height = this.textRef.current.clientHeight;
    if (height >= 50) {
      this.setState({ hasReadMore: true });
    }
  }

  render() {
    const isGood = this.props.type === "good";

    return (
      <div
        onClick={() => this.props.onClick()}
        className={
          "AnnotationItem" +
          (this.props.active ? " AnnotationItem-Active" : "") +
          (isGood ? " Good" : " Bad")
        }
      >
        <p ref={this.textRef}>{this.props.text}</p>
        {this.state.hasReadMore ? (
          <div
            id="Read-More"
            className="Link"
            onClick={() => {
              alert(this.props.text);
            }}
          >
            Mehr
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AnnotationsSlide.js